import { render, staticRenderFns } from "./ManuscriptList.vue?vue&type=template&id=18cb1c7c&scoped=true"
import script from "./ManuscriptList.vue?vue&type=script&lang=ts"
export * from "./ManuscriptList.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptList.vue?vue&type=style&index=0&id=18cb1c7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cb1c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cb1c7c')) {
      api.createRecord('18cb1c7c', component.options)
    } else {
      api.reload('18cb1c7c', component.options)
    }
    module.hot.accept("./ManuscriptList.vue?vue&type=template&id=18cb1c7c&scoped=true", function () {
      api.rerender('18cb1c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ManuscriptList.vue"
export default component.exports